import React, { memo } from 'react';
import { reduxForm } from 'redux-form';
import { func, bool } from 'prop-types';
import Radium from 'radium';
import { handleKeyDown } from '@widergy/utilitygo-forms-web';
import { UTButton } from '@widergy/energy-ui';

import { EMAIL, appConfig } from 'config/customization';
import UTForm from 'app/components/UTForm';
import { message } from 'utils/stringUtils';
import { ACCOUNT_PAYMENT_DOCS } from 'constants/reduxForms';
import { emailField, clientNumberField } from 'constants/fields';

import styles from './styles';

const fields = appConfig.signInMethod === EMAIL ? [emailField, clientNumberField] : [clientNumberField];

const AccountPaymentDocsForm = ({ submitFailed, invalid, handleSubmit, onGoToHome }) => (
  <form onKeyDown={handleKeyDown(handleSubmit)} onSubmit={handleSubmit} style={styles.form}>
    <UTForm fields={fields} />
    <div style={styles.buttonsContainer}>
      {appConfig.accountPaymentDocsForm.showCancelButton && (
        <UTButton secondary onPress={onGoToHome} style={{ ...styles.button, ...styles.cancel }}>
          {message('Commons:cancel')}
        </UTButton>
      )}
      <UTButton disabled={submitFailed && invalid} type="submit" style={styles.button}>
        {message('PublicPayment:getCoupon')}
      </UTButton>
    </div>
  </form>
);

AccountPaymentDocsForm.propTypes = {
  submitFailed: bool,
  invalid: bool,
  handleSubmit: func.isRequired,
  onGoToHome: func.isRequired
};

export default reduxForm({ form: ACCOUNT_PAYMENT_DOCS })(memo(Radium(AccountPaymentDocsForm)));
